import { axios, def, handleError } from './internal';

function AdminServiceKpi(setData, service = 'loise') {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_service_kpi', { service })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, ...(res.data.data ?? {}) });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

export { AdminServiceKpi };
